if(!customElements.get('countdown-timer')){
    class CountdownTimer extends HTMLElement {
        constructor(){
            super();

            this.timerDateInput = this.dataset.date;
            if(!this.isValidDateFormat(this.timerDateInput)) return;
        
            this.targetDate = new Date(this.timerDateInput);

            this.startCountdown();

            this.format = this.dataset.format;
            if(this.format === 'short'){
                this.time = window.countdown.short;
            }else if(this.format === 'long'){
                this.time = window.countdown.long;
            }
        }

        startCountdown(){
            if(this.countdownInterval){
                clearInterval(this.countdownInterval);
            }

            this.countdownInterval = setInterval(() => {
                const today = new Date();
                const timeDiff = this.targetDate - today;

                if(timeDiff <= 0){
                    clearInterval(this.countdownInterval);
                    return;
                }

                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

                const wordDay = this.format === 'short'? this.time.day : days > 1? this.time.other.day : this.time.one.day;
                const wordHour = this.format === 'short'? this.time.hour : days > 1? this.time.other.hour : this.time.one.hour;
                const wordMinute = this.format === 'short'? this.time.hour : days > 1? this.time.other.hour : this.time.one.hour;
                const wordSecond = this.format === 'short'? this.time.second : days > 1? this.time.other.second : this.time.one.second;

                // make it two digits
                const formattedHours = hours.toString().padStart(2, '0');
                const formattedMinutes = minutes.toString().padStart(2, '0');
                const formattedSeconds = seconds.toString().padStart(2, '0');

                this.innerHTML = `<span><strong>${days}</strong><span>${wordDay}</span></span> <span><strong>${formattedHours}</strong><span>${wordHour}</span></span> <span><strong>${formattedMinutes}</strong><span>${wordMinute}</span></span> <span><strong>${formattedSeconds}</strong><span>${wordSecond}</span></span>`;
            }, 1000);
        }

        isValidDateFormat(dateString) {
            const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
            return dateFormatRegex.test(dateString);
        }
    }

    customElements.define('countdown-timer', CountdownTimer);
}